module.exports = __webpack_public_path__ + "static/media/RightCaret.668aabc3.svg";